<div id="main">
  <div>
    <h2>News About Me</h2>
    <div>
      <h3>Articles About Me</h3>
      <app-feed id="article-feed" [feedLocation]="'Articles'"></app-feed>
    </div>
  </div>
  <div>
    <h2>Puppy News!</h2>
    <app-feed id="puppy-feed" [feedLocation]="'Puppy'"></app-feed>
  </div>

  <div>
    <h2>News About Things That Interest Me</h2>
    <div>
      <h3>Apple News</h3>
      <app-feed id="apple-feed" [feedLocation]="'Apple'"></app-feed>
    </div>
    <div>
      <h3>Anime News</h3>
      <app-feed id="anime-feed" [feedLocation]="'Anime'"></app-feed>
    </div>
    <div>
      <h3>Blockchain News</h3>
      <app-feed id="blockchain-feed" [feedLocation]="'Blockchain'"></app-feed>
    </div>
  </div>
</div>
